<template>
  <div class="h-11/12">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div :class="profile.role === 'student' ? 'md:col-span-2' : ''">
        <p>Avatar</p>
        <div class="flex mt-1 items-center">
          <img :src="getProfile.avatar_url" class="rounded-full object-cover h-24 w-24" />
          <!-- <div lass="h-24 w-24 object-cover bg-center rounded-full"
            :style="{
              backgroundImage:
                'url(' + encodeImageURI(getProfile.avatar_url) + ') ',
            }"
          /> -->
          <div class="ml-5">
            <button
              class="px-4 py-2 bg-input rounded cursor-pointer text-gray-500"
              @click.prevent="openPopupChooseAvatar"
            >
              Change Avatar
            </button>
          </div>
        </div>
      </div>
      <div v-if="profile.role === 'teacher'" class="flex flex-col self-end">
        <div>
          Universe Profile URL
          <i
            class="fas fa-question-circle text-gray-300 hover:text-primary"
            v-my-tooltip="{
              content: tooltip_content,
              placement: 'top',
              classes: ['universe-profile-url'],
            }"
            aria-hidden="true"
          />
        </div>
        <div class="flex">
          <span
            class="flex items-center rounded rounded-r-none outline-none px-2 text-sm bg-gray-200 text-gray-500 cursor-default"
          >
            universe.parlayideas.com/profiles/
          </span>
          <input
            v-model="profile_url"
            class="bg-input text-sm text-gray-500 flex-grow outline-none pl-1 pr-4 py-2 w-full rounded rounded-l-none placeholder-gray-300"
            :placeholder="'Profile URL'"
            type="text"
            @input="checkProfileUrlExistence(profile_url)"
          />
          <div class="flex items-center rounded-lg space-x-4 mx-auto">
            <button
              :data-clipboard-text="sharing_teacher_url"
              class="sharing_teacher_url bg-primary text-white rounded-l-none rounded-r-md px-4 py-2 text-sm cursor-pointer"
            >
              <i class="fas fa-copy"></i>
            </button>
          </div>
        </div>
        <div class="h-5 text-red-500 italic text-xs">
          {{ profileUrlTaken ? 'Profile URL already taken.' : '' }}
          {{
            profileInvalidChars
              ? 'Only lowercase letters, numbers and dashes are allowed.'
              : ''
          }}
          {{
            profileUrlCannotBeEmpty
              ? 'Profile URL cannot be empty and must be between 3 and 99 characters'
              : ''
          }}
        </div>
      </div>
      <div>
        <p>Name</p>
        <input
          v-model="name"
          class="bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300"
          :placeholder="'Name'"
          type="text"
          @input="checkName(name)"
        />
        <div class="h-5 text-red-500 italic text-xs">
          {{ nameIsRequired ? 'Your name is required' : '' }}
          {{
            nameValidation
              ? 'Your name must be between 2 and 99 characters'
              : ''
          }}
        </div>
      </div>
      <div>
        <p>Preferred Name</p>
        <input
          v-model="preferred_name"
          class="bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300"
          :placeholder="'Preferred Name'"
          type="text"
          @input="checkPreferredName(preferred_name)"
        />
        <div class="h-5 text-red-500 italic text-xs">
          {{
            preferredNameValidation
              ? 'Your preferred name must be between 2 and 99 characters'
              : ''
          }}
        </div>
      </div>
      <div v-if="profile.role === 'teacher'" class="md:col-span-2">
        <p>About</p>
        <textarea
          v-model="description"
          class="bg-input text-sm text-gray-500 flex-grow outline-none px-3 py-2 w-full rounded placeholder-gray-300 h-28 resize-none"
          :placeholder="'Tell us a little bit about yourself'"
          type="text"
        />
      </div>
      <!-- subjects -->
      <div v-if="profile.role === 'teacher'">
        <p>Subjects/Topics</p>
        <pl-multiselect
          v-model="selectedSubjects"
          :options="subjects"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :show-labels="false"
          placeholder="Select subjects"
          label="name"
          track-by="id"
        >
          <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
              v-if="selectedSubjects && selectedSubjects.length &amp;&amp; !isOpen"
              class="multiselect__single"
            >
              {{ selectedSubjects.length }} options selected
            </span>
          </template>
        </pl-multiselect>
      </div>
      <!-- grades -->
      <div v-if="profile.role === 'teacher'">
        <p>Grade Levels</p>
        <pl-multiselect
          v-model="selectedGradeLevels"
          :options="gradeLevels"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :preselect-first="false"
          :show-labels="false"
          placeholder="Select grades"
          label="grade"
          track-by="id"
        >
          <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
              v-if="selectedGradeLevels && selectedGradeLevels.length &amp;&amp; !isOpen"
              class="multiselect__single"
            >
              {{ selectedGradeLevels.length }} options selected
            </span>
          </template>
        </pl-multiselect>
      </div>
      <div class="my-5">
        <button
          :disabled="disabledButton"
          class="px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50"
          @click="updateProfile()"
        >
          Save Changes
        </button>
      </div>
    </div>

    <choose-avatar
      @close="show_choose_avatar_modal = false"
      v-if="show_choose_avatar_modal"
    />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  import ChooseAvatar from 'components/modals/chooseAvatar.vue';
  import updateUser from 'services/account/updateUser';
  import { encodeImageUrl } from 'utils/encodeImage';
  import { makeRequest } from 'utils/requestLogger';

  import { EventBus } from 'utils/event-bus';

  import Clipboard from 'clipboard';

  import profileServices from 'services/profile/profileServices';

  export default {
    data() {
      return {
        clipboard: '',
        name: null,
        preferred_name: null,
        description: '',
        profile_url: null,
        subjects: [],
        initialSubjects: [],
        selectedSubjects: [],
        gradeLevels: [],
        initialGradeLevels: [],
        selectedGradeLevels: [],
        selected_tab: 'personal_info',
        show_choose_avatar_modal: false,
        nameIsRequired: false,
        nameValidation: false,
        preferredNameValidation: false,
        profileUrlCannotBeEmpty: false,
        profileUrlTaken: false,
        profileInvalidChars: false,
        tooltip_content:
          '<div class="pt-2.5 pb-5 text-xs"><p class="px-5 pb-2.5"> This is the unique URL for your teacher portfolio in the Parlay Universe. </p><p class="px-5 pt-2.5">When you create discussion topics, you can add the prompt to your portfolio to share with your colleagues and other teachers around the world.</p></div> ',
      };
    },
    components: {
      ChooseAvatar,
    },
    computed: {
      ...mapGetters(['getProfile', 'getCourseDetail']),
      profile() {
        return this.$store.getters.getProfile;
      },
      disabledButton() {
        if (this.getProfile.role === 'teacher') {
          return (
            this.nameIsRequired ||
            this.profileUrlTaken ||
            this.profileInvalidChars ||
            this.profileUrlCannotBeEmpty
          );
        } else {
          return (
            this.nameIsRequired ||
            this.nameValidation ||
            this.preferredNameValidation
          );
        }
      },
      sharing_teacher_url() {
        return `universe.parlayideas.com/profiles/${this.profile_url}`;
      },
    },
    methods: {
      createProfileUrl() {
        profileServices
          .createProfile(this.getProfile.id)
          .then(({ data }) => {
            this.profile_url = data.profile_url;
          })
          .catch((error) => {
            console.error(error);
          });
      },
      loadGradeLevels() {
        this.$store.dispatch('getAllGrades').then((results) => {
          this.gradeLevels = results;
        });
      },
      loadSubjects() {
        this.$store.dispatch('getSubjects').then((results) => {
          this.subjects = results;
        });
      },
      encodeImageURI(image_url) {
        return encodeImageUrl(image_url);
      },
      openPopupChooseAvatar() {
        this.show_choose_avatar_modal = true;
      },

      selectUnselectSubjects(id) {
        const index = this.selectedSubjects.findIndex((s) => s === id);
        if (index > -1) {
          this.selectedSubjects.splice(index, 1);
        } else {
          this.selectedSubjects.push(id);
        }
      },
      selectUnselectGrades(id) {
        const index = this.selectedGradeLevels.findIndex((s) => s === id);
        if (index > -1) {
          this.selectedGradeLevels.splice(index, 1);
        } else {
          this.selectedGradeLevels.push(id);
        }
      },
      checkProfileUrlExistence(profileName) {
        this.profileUrlCannotBeEmpty = !profileName;
        if (this.profileUrlCannotBeEmpty) {
          this.profileUrlTaken = false;
          this.profileInvalidChars = false;
        }
        if (
          !this.profileUrlCannotBeEmpty &&
          (profileName.length < 3 || profileName.length > 99)
        ) {
          this.profileUrlCannotBeEmpty = true;
          this.profileUrlTaken = false;
          this.profileInvalidChars = false;
          return;
        }

        // We only allow lowercase letters, numbers and the dash symbol.
        const validUrlChars = 'abcdefghijklmnopqrstuvwxyz0123456789-';
        this.profileInvalidChars = false;
        for (var i = 0; i < profileName.length; i++) {
          if (validUrlChars.indexOf(profileName.charAt(i)) === -1) {
            this.profileInvalidChars = true;
            this.profileUrlTaken = false;
            this.profileUrlCannotBeEmpty = false;
            return;
          }
        }
        if (!this.profileInvalidChars && profileName) {
          makeRequest('get', `/api/profiles/url?search=${profileName}`)
            .then((res) => {
              if (res.data) {
                this.profileUrlTaken = false;
              } else if (
                !res.data &&
                profileName.toLowerCase() !==
                  this.getProfile.profile_url.toLowerCase()
              ) {
                this.profileUrlTaken = true;
                this.profileInvalidChars = false;
                this.profileUrlCannotBeEmpty = false;
                return;
              }
            })
            .catch((err) => {
              console.error(err);
              this.profileUrlTaken = true;
            });
        }
      },
      checkName(name) {
        if (!name || name.trim() === '') {
          this.nameIsRequired = true;
          return null;
        } else if ((name && name.length < 2) || name.length > 99) {
          this.nameValidation = true;
          return null;
        }
        this.nameIsRequired = false;
        this.nameValidation = false;
      },
      checkPreferredName(new_preferred_name) {
        if (
          new_preferred_name !== null &&
          new_preferred_name !== '' &&
          (new_preferred_name.length < 2 || new_preferred_name.length > 99)
        ) {
          this.preferredNameValidation = true;
          return null;
        }
        this.preferredNameValidation = false;
      },
      updateProfile() {
        const user_payload = {};
        const initial_subjects_ids = this.initialSubjects.map((s) => s.id);
        const initial_grades_ids = this.initialGradeLevels.map((g) => g.id);
        const selected_subjects_ids = this.selectedSubjects.map((s) => s.id);
        const selected_grades_ids = this.selectedGradeLevels.map((g) => g.id);

        const a = selected_subjects_ids.filter(
          (s) => !initial_subjects_ids.includes(s)
        );
        const b = selected_grades_ids.filter(
          (g) => !initial_grades_ids.includes(g)
        );
        const c = initial_subjects_ids.filter(
          (s) => !selected_subjects_ids.includes(s)
        );
        const d = initial_grades_ids.filter(
          (g) => !selected_grades_ids.includes(g)
        );

        const diff_subjects = a.concat(c);
        const diff_grades = b.concat(d);

        user_payload.name = this.name.trim();
        user_payload.profile_url = this.profile_url.toLowerCase();
        if (this.preferred_name && this.preferred_name.trim() !== '') {
          user_payload.preferred_name = this.preferred_name.trim();
        }
        if (this.description && this.description.trim() !== '') {
          user_payload.description = this.description.trim();
        }
        user_payload.subjects = this.selectedSubjects.map((s) => {
          return { id: s.id };
        });
        user_payload.grade_levels = this.selectedGradeLevels.map((g) => {
          return { id: g.id };
        });

        user_payload.subjects_changed = diff_subjects.length ? true : false;
        user_payload.grade_levels_changed = diff_grades.length ? true : false;

        return updateUser(this.profile.id, user_payload)
          .then((res) => {
            this.$store.dispatch('setAccount', res.data);
            const toast = {
              type: 'Success',
              message: 'Basic information updated with success!',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          })
          .catch((e) => {
            console.error(e);
            const toast = {
              type: 'Error',
              message: 'There was an error in updating information!',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          });
      },
    },
    created() {
      const sessionID = sessionStorage.getItem('stripe_session_id');
      if (sessionID) {
        if (this.$route.query.session_id === sessionID) {
          this.upgradeStripeUser();
        }
        sessionStorage.removeItem('stripe_session_id');
        let query = Object.assign({}, this.$route.query);
        delete query.session_id;
        this.$router.replace({ query });
      }
    },
    mounted() {
      this.clipboard = new Clipboard('.sharing_teacher_url');
      this.name = this.getProfile.name;
      this.preferred_name = this.getProfile.preferred_name;
      this.description = this.getProfile.description;
      if (this.getProfile.id && this.getProfile.profile_url === null) {
        this.createProfileUrl();
      } else {
        this.profile_url = this.getProfile.profile_url;
        this.checkProfileUrlExistence(this.profile_url);
      }
      this.initialGradeLevels = this.getProfile.grade_levels;
      this.initialSubjects = this.getProfile.subjects;
      this.selectedGradeLevels = this.getProfile.grade_levels;
      this.selectedSubjects = this.getProfile.subjects;
      this.loadSubjects();
      this.loadGradeLevels();
      const toast = {
        type: 'Success',
        message: 'Link copied with success!',
        time: 5000,
      };
      this.clipboard.on('success', () => {
        EventBus.$emit('createToast', toast);
      });
    },
    beforeDestroy() {
      this.clipboard && this.clipboard.destroy();
    },
  };
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  .multiselect {
    min-height: 2.25rem;
    max-width: 100% !important;
  }
  .multiselect .multiselect__content-wrapper {
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
  .multiselect .multiselect__clear {
    position: absolute;
    right: 2.5rem;
    height: 2.25rem;
    width: 2.5rem;
    display: block;
    cursor: pointer;
    z-index: 2;
  }

  .multiselect .multiselect__clear:after,
  .multiselect .multiselect__clear:before {
    content: '';
    display: block;
    position: absolute;
    width: 0.125rem;
    height: 0.75rem;
    background: #aaa;
    top: 0.625rem;
    right: 0.25rem;
    cursor: pointer;
  }

  .multiselect .multiselect__clear:before {
    transform: rotate(45deg);
  }

  .multiselect .multiselect__clear:after {
    transform: rotate(-45deg);
  }

  .multiselect .multiselect__option {
    font-size: 0.875rem;
    padding: 0.375rem 0.5rem;
    min-height: 2.25rem;
  }

  .multiselect .multiselect__input,
  .multiselect .multiselect__single {
    background-color: #f5f8fa;
    font-size: 0.875rem !important;
    padding: 0;
    margin-bottom: 0.5rem;
  }

  .multiselect .multiselect__placeholder {
    padding-top: 0;
    margin-bottom: 0;
    color: #9ca3af;
  }

  .multiselect .multiselect__select {
    height: 1.875rem;
  }

  .multiselect .multiselect__select:before {
    top: 1rem;
  }

  .multiselect .multiselect__tags {
    min-height: 2.25rem;
    padding-top: 0.5rem;
    padding-left: 0.75rem;
    background-color: #f5f8fa;
    border: 0;
  }

  .multiselect .multiselect__option--highlight {
    background-color: rgb(114, 204, 215);
  }

  .multiselect .multiselect__tag {
    background-color: #72ccd7;
  }

  span.multiselect__tag {
    background: #72ccd7;
  }

  i.multiselect__tag-icon:hover {
    background-color: #72ccd7;
  }

  span.multiselect__option.multiselect__option--highlight {
    background: #72ccd7;
  }
  span.multiselect__option.multiselect__option-selected {
    margin-right: 70px !important;
  }

  span.multiselect__option.multiselect__option--highlight:after {
    background: #72ccd7;
  }
</style>



// WEBPACK FOOTER //
// basicInfoTab.vue?375cd3b0